module.exports = __webpack_public_path__ + "img/logo_short.7899ba49.png";